<template lang="pug">
  div(id="2GisMap", :style="mapStyles")
</template>
<script>
export default {
  props: {
    point: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    map: null,
    marker: null,
    mapStyles: {
      width: '100%',
      height: '300px'
    }
  }),
  mounted() {
    this.initMap()
  },
  methods: {
    setPin(coords) {
      const DG = require('2gis-maps')
      if (this.marker) this.marker.remove()
      this.map.setView(coords, 17)
      this.marker = DG.marker(coords, { draggable: true })
        .addTo(this.map)
        .on('drag', e => {
          this.$emit('set-coords', e.latlng)
        })
    },
    initMap() {
      const DG = require('2gis-maps')
      DG.then(async () => {
        this.map = await DG.map('2GisMap', {
          zoomControl: true,
          fullscreenControl: true,
          dragging: true,
          scrollWheelZoom: false
        })
        if (this.point !== null) {
          this.setPin({ lat: this.point.latitude, lng: this.point.longitude })
        } else {
          this.map.locate({ setView: true }).on('locationfound', l => {
            this.setPin({ lat: l.latitude, lng: l.longitude })
          })
        }
      })
    }
  }
}
</script>
